import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from '@ngrx/store';
import { CmsCountryObj } from 'src/app/app.models';
import { defaultCountry } from '../service-options/service-options.selectors';
import { stateInfo } from '../states/states.selectors';
import { CountriesState, CountryDetails } from './countries.model';
import { getCurrentLabelsJson } from '../labels/labels.selector';

const selectState = createFeatureSelector<CountriesState>('countriesState');

export const countriesState = createSelector(
  selectState,
  (state: CountriesState) => state
);

export const countriesInfo = createSelector(
  countriesState,
  (state: CountriesState) => state.countries
);

export const selectedCountry = createSelector(
  countriesState,
  (state: CountriesState) => state?.selectedCountry
);

export const getCountryDetails: MemoizedSelector<
  CountriesState,
  CmsCountryObj
> = createSelector(
  [countriesInfo, defaultCountry, stateInfo],
  (availCountries, country, states) => {
    return availCountries.find(
      (count: CmsCountryObj) => count.code === country
    );
  }
);

export const getCMSLabelsandCountriesInfo: MemoizedSelector<any, any> =
  createSelector(
    [countriesInfo, getCurrentLabelsJson],
    (availCountries, labels) => {
      return {
        availCountries,
        labels,
      };
    }
  );
